define('view/controller/booking/details/DetailsLicenseView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    /**
     * License view to display symplybook.me and users terms and conditions
     *
     * @class DetailsLicenseView
     */
    return LayoutView.extend({

        template: '#license_view',
        modelEvents: {
            'sync': 'render'
        },
        ui: {
            'agreeBtn': '#sb_confirm_license',
            'lang': '.sb-terms-lang'
        },
        events: {
            'change @ui.lang': 'onChangeLang'
        },
        triggers: {
            'click @ui.agreeBtn': {
                'event': 'confirm',
                'stopPropagation': false
            }
        },

        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);
            data.title = this.getOption('title');
            data.company = Config.getInstance().getOption('company_data');
            data.server_address = Config.getInstance().getOption('server_address');

            return data;
        },
        
        onChangeLang: function () {
            this.model.fetchLanguage(this.ui.lang.val());
        }

    });

});
